import React, { useEffect } from 'react';
import { useAuthStore } from '@/core/auth/auth.store';
import { Footer } from '@/shared/components/layout/Footer';

const SessionFinishedPage = () => {
    const { resetUser } = useAuthStore();

    // Página terminal: limpiar user para no arrastrar datos a una próxima sesión SSO.
    useEffect(() => {
        resetUser();
        sessionStorage.removeItem('vitalsProfile');
    }, [resetUser]);

    return (
        <>
            <div className="container-vitals">
                <section className="section-vitals form-vitals m-3">
                    <div className="title-vitals">
                        <i className="icon icon_enlinea_success"></i>
                        La sesión ha finalizado
                    </div>

                    <span className="text-vitals">
                        Por tu seguridad, esta sesión ya no se encuentra activa.
                    </span>
                    <span className="text-vitals">
                        Cierra esta pestaña para continuar.
                    </span>
                </section>
            </div>

            <Footer/>
        </>
    );
};

export {SessionFinishedPage};